import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import { outlet } from 'lit-element-router';
import {cssProperties} from '../css/cssProperties';
import {cssVars} from '../css/styleSets';

@customElement('main-configurator')
export class MainConfigurator extends outlet(LitElement) {
	static styles = [
		cssVars,
		cssProperties,
		css`
		  :host {
			height: 100%;
			display:flex;
			flex-direction: column;
		  }
		`
	];
	render() {
		return html`
			<slot></slot>
		`;
	}
}
